<template>
  <div :class="winSize">
    <router-view v-slot="{ Component }">
      <keep-alive :include="['login']">
        <component :is="Component" />
      </keep-alive>
      <dragBtn v-if="userStore.loginStatus"></dragBtn>
    </router-view>
  </div>
</template>

<script setup>
  import { isMobile } from '@/utils/util';
  import { storage } from '@/utils/storage';
  import debug from '@/utils/debug';
  import Adjust from '@adjustcom/adjust-web-sdk';
  // import watermark from '@/utils/lib/watermark';
  // import copyPaste from '@/utils/lib/copy-paste';
  import { geo } from '@/utils';

  import { useUserStore } from '@/store';
  const userStore = useUserStore();
  // let token = storage.getItem('userToken');
  // const getGeo = async () => {
  //   let position = {};
  //   position = await geo.getLocation();
  //   storage.setItem('position', JSON.stringify(position));
  //   console.log('position------', position);
  // };
  // getGeo();

  let winSize = ref('pc');
  if (isMobile()) {
    winSize.value = 'mobile';
  } else {
    winSize.value = 'pc';
  }

  onMounted(() => {
    const script = document.createElement('script');
    script.innerHTML = `
          !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '612348731949553');
            fbq('track', 'PageView');
        `;
    document.head.appendChild(script);
    // 动态插入 noscript 部分
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=612348731949553&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.prepend(noscript);

    debug.init();

    // const { username = '', mobile = '' } = auth.getUser();
    // watermark.add({
    // content: username + ' ' + mobile,
    // });
    // copyPaste.disable();
  });

  const initAD = () => {
    let isProd = location.href.indexOf('//webapp.morloan.co') >= 0;
    console.log('Adjust---', Adjust);
    console.log('isProd---', isProd);

    try {
      Adjust.initSdk({
        appToken: '4ydwljf1bthc',
        environment: isProd ? 'production' : 'sandbox',
        logLevel: isProd ? 'none' : 'verbose',
        attributionCallback: (e, attribution) => {
          console.log('initAD--ok', attribution);
          storage.setItem('adjust_id', attribution.adid);
          if (isProd) {
            return;
          }
          console.log('attributionCallback_Adid: ' + attribution.adid);
          console.log('attributionCallback_Tracker Token: ' + attribution.tracker_token);
          console.log('attributionCallback_Tracker Name: ' + attribution.tracker_name);
          console.log('attributionCallback_Network: ' + attribution.network);
          console.log('attributionCallback_Campaign: ' + attribution.campaign);
          console.log('attributionCallback_Adgroup: ' + attribution.adgroup);
          console.log('attributionCallback_Creative: ' + attribution.creative);
          console.log('attributionCallback_Click Label: ' + attribution.click_label);
          console.log('attributionCallback_Attribution State: ' + attribution.state);
        },
      });
    } catch (error) {
      console.log('initAD--err', error);

      if (isProd) {
        return;
      }
      console.log('attributionCallback_error: ' + error);
    }
  };
  initAD();

  onBeforeUnmount(() => {
    // watermark.remove();
    // copyPaste.enable();
  });
</script>

<style>
  #app {
    font-family: Roboto, Roboto;
    font-synthesis: none;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
    background: #f6f7f8;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
    transition: background-color 5000s ease-in-out 0s;
  }
</style>
